<template>
  <div>
    <logged-in-header />
    <stockouts />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import stockouts from "../components/stockouts/Stockouts";

export default {
  components: {
    loggedInHeader,
    stockouts
  }
};
</script>
